import { render } from "./StatisticsChart.vue?vue&type=template&id=863114b4&scoped=true"
import script from "./StatisticsChart.vue?vue&type=script&lang=js"
export * from "./StatisticsChart.vue?vue&type=script&lang=js"

import "./StatisticsChart.vue?vue&type=style&index=0&id=863114b4&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-863114b4"]])

export default __exports__